import "../styles/global.css";

export default function Footer() {
  return (
    <footer style={styles.footer}>
      <p>© {new Date().getFullYear()} DigitalPro — Tous droits réservés</p>
      <p>Services digitaux • Informatique • Formation</p>
    </footer>
  );
}

const styles = {
  footer: {
    background: "#0b0e14",
    padding: "30px 10%",
    textAlign: "center",
    marginTop: "80px",
    borderTop: "1px solid #1f2937",
    color: "#9ca3af"
  }
};
